import { IMkAuthenticatedSession, IMkAuthorizedSession } from '@auth/types'

/**
 * Type guard to check if an object is an authenticated session
 */
export function isAuthenticatedSession(obj: any): obj is IMkAuthenticatedSession {
  return (
    obj &&
    typeof obj === 'object' &&
    obj.sessionType === 'authenticated' &&
    typeof obj.authBrand === 'string' &&
    obj.authenticatedUser &&
    typeof obj.codeVerifier === 'string' &&
    typeof obj.username === 'string' &&
    typeof obj.sessionToken === 'string' &&
    typeof obj.recoveryToken === 'string'
  )
}

/**
 * Type guard to check if an object is an authorized session
 */
export function isAuthorizedSession(obj: any): obj is IMkAuthorizedSession {
  return (
    obj &&
    typeof obj === 'object' &&
    obj.sessionType === 'authorized' &&
    typeof obj.authBrand === 'string' &&
    obj.authorizedUser &&
    typeof obj.authenticatedUserName === 'string' &&
    typeof obj.sessionToken === 'string' &&
    typeof obj.recoveryToken === 'string'
  )
}

/**
 * Type guard to check if an object is any valid session type
 */
export function isSession(obj: any): obj is IMkAuthenticatedSession | IMkAuthorizedSession {
  return isAuthenticatedSession(obj) || isAuthorizedSession(obj)
}

/**
 * Utility to get the session type as a string
 */
export function getSessionType(obj: any): 'authenticated' | 'authorized' | 'unknown' {
  if (isAuthenticatedSession(obj)) return 'authenticated'
  if (isAuthorizedSession(obj)) return 'authorized'
  return 'unknown'
}
